if (!customElements.get("rdm-chart-timeline")) {
  customElements.define("rdm-chart-timeline", class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.tabs = Array.from(this.querySelectorAll("[data-tab]"));
      this.panels = Array.from(this.querySelectorAll("[data-panel]"));
      this.tablist = this.querySelector("[data-tabs]");
      if (!this.tabs.length || !this.tablist) return;

      this.tablist.setAttribute("role", "tablist");
      this.querySelectorAll("[data-stage-label]").forEach(label => { label.hidden = true; });
      this.tabs.forEach((tab, index) => {
        tab.setAttribute("role", "tab");
        this.panels[index].setAttribute("role", "tabpanel");
        this.panels[index].setAttribute("aria-labelledby", tab.id);
        this.panels[index].tabIndex = 0;
      });
      const currentIndex = this.tabs.findIndex(tab => tab.dataset.blockId === this.activeBlockId);
      this.activate(currentIndex < 0 ? 0 : currentIndex);
      this.setAttribute("data-initialized", "");
      this.tablist.hidden = false;

      this.tablist.addEventListener("click", event => {
        const index = this.tabs.indexOf(event.target.closest("[data-tab]"));
        if (index >= 0) this.activate(index);
      }, { signal });
      this.tablist.addEventListener("keydown", event => {
        const index = this.tabs.indexOf(event.target.closest("[data-tab]"));
        if (index < 0) return;
        const direction = getComputedStyle(this).direction === "rtl" ? -1 : 1;
        let next;
        if (event.key === "ArrowRight") next = index + direction;
        if (event.key === "ArrowLeft") next = index - direction;
        if (event.key === "Home") next = 0;
        if (event.key === "End") next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.activate(next);
        this.tabs[next].focus();
      }, { signal });
      document.addEventListener("shopify:block:select", event => {
        const index = this.tabs.findIndex(tab => tab.dataset.blockId === event.detail?.blockId);
        if (index >= 0 && this.contains(event.target)) this.activate(index);
      }, { signal });
      this.addEventListener("click", event => {
        const link = event.target.closest("[data-scroll-top]");
        if (!link || !this.contains(link)) return;
        const target = document.querySelector(".main-product__info") || document.getElementById("MainContent");
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" });
      }, { signal });
    }

    activate(index) {
      this.activeBlockId = this.tabs[index].dataset.blockId;
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.setAttribute("aria-selected", String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[tabIndex].inert = !active;
        this.panels[tabIndex].setAttribute("aria-hidden", String(!active));
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.removeAttribute("data-initialized");
      if (this.tablist) this.tablist.hidden = true;
      this.querySelectorAll("[data-stage-label]").forEach(label => { label.hidden = false; });
      this.panels?.forEach(panel => {
        panel.inert = false;
        panel.removeAttribute("aria-hidden");
        panel.removeAttribute("role");
        panel.removeAttribute("aria-labelledby");
        panel.removeAttribute("tabindex");
      });
    }
  });
}
